module.exports = __webpack_public_path__ + "img/1280x720-Autumn.3555ccf7.jpg";